var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenTokenBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 7,
    fill: "#C5FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 13.26L16.0002 16.33L21.2602 13.28",
    stroke: "#008F99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.7701V16.3201",
    stroke: "#008F99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7603 10.2901L11.5602 12.0701C10.8402 12.4701 10.2402 13.4801 10.2402 14.3101V17.7001C10.2402 18.5301 10.8302 19.5401 11.5602 19.9401L14.7603 21.7201C15.4403 22.1001 16.5602 22.1001 17.2502 21.7201L20.4503 19.9401C21.1703 19.5401 21.7702 18.5301 21.7702 17.7001V14.3001C21.7702 13.4701 21.1803 12.4601 20.4503 12.0601L17.2502 10.2801C16.5602 9.9001 15.4403 9.9001 14.7603 10.2901Z",
    stroke: "#008F99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19C26 22.87 22.87 26 19 26L20.05 24.25",
    stroke: "#008F99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13C6 9.13 9.13 6 13 6L11.95 7.75",
    stroke: "#008F99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenTokenBg);
export default __webpack_public_path__ + "static/media/gen-token-bg.85459b479d33ae6b0c84d5b0fac02984.svg";
export { ForwardRef as ReactComponent };